var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.token),expression:"$store.state.token"}]}),_c('router-link',{attrs:{"to":"/"}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }